enum BannerImageType {
  Front = 1,
}

export default BannerImageType;
